import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ColetorCustosService } from 'src/app/_services';
import { FileUploadModel, RateioDespesas, ColetorCustos, DocumentoPreEditadoFiscal } from 'src/app/_models';
import {
  HttpClient
} from '@angular/common/http';
import * as XLSX from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { AppComponent } from '../../app.component';
import { ProtocoloFiscalComponent } from 'src/app/_pages/protocolo-fiscal/protocolo-fiscal.component';
import { DocumentoService } from 'src/app/_services/documento.service';
import { PopUpColetoresComponent } from '../popupColetores/popupColetores.component';

@Component({
  selector: 'app-planilha-fiscal',
  templateUrl: './planilha-fiscal.component.html',
  styleUrls: ['./planilha-fiscal.component.css']
})
export class PlanilhaFiscalComponent implements OnInit {
  type: string;
  private files: Array<FileUploadModel> = [];
  arrayBuffer: any;
  @Input() protocolo: DocumentoPreEditadoFiscal;

  /** Link text */
  @Input() text = 'Upload';
  /** Name used in form which will be sent in HTTP request. */
  @Input() param = 'file';
  /** Target URL for file uploading. */
  @Input() target = 'https://file.io';
  /** File extension that accepted, same as 'accept' of <input type="file" />. 
      By the default, it's set to 'image/*'. */
  @Input() accept = '.xlsx';
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<string>();

  stopProcess = false as boolean;

  constructor(
    private loadComponent: AppComponent,
    private documentoService: DocumentoService,
    private _http: HttpClient,
    public protocoloFiscal: ProtocoloFiscalComponent,
    private apiColetorCustos: ColetorCustosService,
    private dialog?: MatDialog,
  ) {
    this.protocolo = {} as DocumentoPreEditadoFiscal;
    if (!this.protocolo.rateios) {
      this.protocolo.rateios = Array<RateioDespesas>();
    }
  }

  ngOnInit() {
    this.type = this.type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  getFile() {
    this.documentoService.getPlanilhaRateioFiscal().subscribe(respData => {
      this.downloadPlanilhaRateio(respData, this.type);
    }, error => {
      console.log(error);
    });
  }

  downloadPlanilhaRateio(data: any, type: string) {
    const blob = new Blob([data], { type: type.toString() });
    const a = document.createElement('a');
    const fileURL = URL.createObjectURL(blob);
    a.href = fileURL;
    a.download = 'PlanilhaRateio.xlsx';
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    URL.revokeObjectURL(fileURL);
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

  private uploadFiles() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';

    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }

  anexarPlanilha() {
    if (this.protocoloFiscal.empresaInvalida()) {
      return;
    }

    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.click();
  }

  selecionarArquivo(event) {
    const fileUpload = event.target.files;

    if (fileUpload === null) {
      return;
    }

    for (let index = 0; index < fileUpload.length; index++) {
      const file = fileUpload[index];
      this.files.push({
        data: file, state: 'in',
        inProgress: false, progress: 0, canRetry: false, canCancel: true
      });
    }
    this.uploadFiles();
  }


  private uploadFile(file: FileUploadModel) {
    const fileReader = new FileReader();
    let codDespesaNaoEncontrado = '';
    const descricaoNaoEncontrado = false;
    let tipoColetorNaoEncontrado = false;
    let valorInvalido = false;
    let listaValorNegativo = new Array<ColetorCustos>();
    let validacoesColetorCustosMensagens = '';
    

    let rateioItemPlanilha = {} as RateioDespesas;
    let lstRateiosDespesas = new Array<RateioDespesas>();

    fileReader.onload = (e) => {
      this.loadComponent.startLoading(true);
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = new Array();
      for (let i = 0; i !== data.length; ++i) { arr[i] = String.fromCharCode(data[i]); }
      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];
      let jsonPlanilha: Array<any>;
      jsonPlanilha = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      jsonPlanilha.forEach((p, index) => {
        rateioItemPlanilha = {} as RateioDespesas;
        rateioItemPlanilha.item = rateioItemPlanilha.item || null
        rateioItemPlanilha.codTipoColetor = rateioItemPlanilha.codTipoColetor || ''
        rateioItemPlanilha.identificacaoColetor = rateioItemPlanilha.identificacaoColetor || ''
        rateioItemPlanilha.contaRazao = rateioItemPlanilha.contaRazao || ''
        rateioItemPlanilha.usuarioAlteracao = rateioItemPlanilha.usuarioAlteracao || ''
        rateioItemPlanilha.valor = rateioItemPlanilha.valor || 0
        rateioItemPlanilha.codTipoColetor = rateioItemPlanilha.codTipoColetor || ''
        rateioItemPlanilha.operacaoSubNumero = rateioItemPlanilha.operacaoSubNumero || ''

        if(p.VALOR < 0){
          listaValorNegativo.push({idx:(p.__rowNum__ + 1), codColetorCusto: 'MRVPAG-00S1', descMensagem: 'Não é Permitido Valores Negativos!', nomeColetorCusto: "", status:""});
          return;
        }

        if(p.TIPOCOLETOR === 'N' && p.COLETOR.toString().length > 12){
          validacoesColetorCustosMensagens += `<br>- Tipo de Coletor: <b>${p.TIPOCOLETOR} - ${p.COLETOR}</b> não pode conter mais de 12 caracteres. Linha: <b>${p.__rowNum__ + 1}.</b>`;
        }

        if(p.TIPOCOLETOR === 'K' && p.COLETOR.toString().length > 10){
          validacoesColetorCustosMensagens += `<br>- Tipo de Coletor: <b>${p.TIPOCOLETOR} - ${p.COLETOR}</b> não pode conter mais de 10 caracteres. Linha: <b>${p.__rowNum__ + 1}.</b>`
        }

        if (p.ITEM === undefined || p.TIPOCOLETOR === undefined || p.VALOR === undefined) {
          this.stopProcess = true;
          return;
        }

        rateioItemPlanilha.item = p.ITEM;

        if (this.protocoloFiscal.protocolo.produtos.length < p.ITEM) {
          codDespesaNaoEncontrado = p.ITEM;
          return;
        }
        p.TIPOCOLETOR = p.TIPOCOLETOR || null;
        if (p.TIPOCOLETOR == null || p.TIPOCOLETOR === '') {
          tipoColetorNaoEncontrado = true;
          return;
        } else {
          rateioItemPlanilha.codTipoColetor = p.TIPOCOLETOR.toUpperCase().replace(' ', '');
          rateioItemPlanilha.identificacaoColetor = p.COLETOR;
          rateioItemPlanilha.contaRazao = this.protocoloFiscal.rateioAdicionado.contaRazao;
        }
        rateioItemPlanilha.usuarioAlteracao = this.protocoloFiscal.currentUser.login;
        rateioItemPlanilha.usuarioCadastro = this.protocoloFiscal.currentUser.login;
        p.VALOR = p.VALOR || null;
        if (p.VALOR === '' || p.VALOR === null) {
          valorInvalido = true;
        } else {
          const valor = p.VALOR.toString().replace('R$', '').trim();
          const valorNumber = Number(valor.replace(',', '.')).toFixed(2);
          rateioItemPlanilha.valor = Number(valorNumber);
        }

        if (!tipoColetorNaoEncontrado) {
          if (rateioItemPlanilha.codTipoColetor.toUpperCase().replace(' ', '') === 'N') {
            p.OPERACAO = p.OPERACAO || ''
            if (p.OPERACAO !== '') {
              rateioItemPlanilha.operacaoSubNumero = p.OPERACAO.toString() || '';
            }
          }

          lstRateiosDespesas.push(rateioItemPlanilha);
        }

        rateioItemPlanilha.descricao = (p.DESCRICAO) ? p.DESCRICAO.toString() : ''
      });

      if(listaValorNegativo.length != 0){
        this.dialog.open(PopUpColetoresComponent, { data: listaValorNegativo });
        this.loadComponent.startLoading(false);
        this.stopProcess = false;
        return
      }

      if (this.stopProcess) {
        this.files.splice(-1, 1);
        this.protocoloFiscal.exibeMensagem('Erro ao realizar upload da planilha', 'O campo do nome da coluna possui espaço ou está com a formatação diferente de Geral');
        this.loadComponent.startLoading(false);
        this.stopProcess = false;
        return;
      }

      if(validacoesColetorCustosMensagens !== ''){
        this.protocoloFiscal.exibeMensagem('Erro ao realizar upload da planilha', validacoesColetorCustosMensagens);
        this.loadComponent.startLoading(false);
        this.stopProcess = false;
      }else {
        lstRateiosDespesas = this.atualizarNumeroSerialNosRateios(lstRateiosDespesas);
        this.validaRateio(lstRateiosDespesas, codDespesaNaoEncontrado, descricaoNaoEncontrado, tipoColetorNaoEncontrado, valorInvalido);
      }

      this.removeFileFromArray(file);

    };
    fileReader.readAsArrayBuffer(file.data);
  }

  validaRateio(lstRateiosDespesas: Array<RateioDespesas>, codDespesaNaoEncontrado: string,
    descricaoNaoEncontrado: boolean, tipoColetorNaoEncontrado: boolean, valorInvalido: boolean) {
    if (codDespesaNaoEncontrado !== '') {
      this.protocoloFiscal.exibeMensagem('Erro ao realizar upload da planilha', `Item ${codDespesaNaoEncontrado} não encontrado.`);
      this.loadComponent.startLoading(false);
      this.stopProcess = false;
      return;
    } else if (tipoColetorNaoEncontrado) {
      this.protocoloFiscal.exibeMensagem('Erro ao realizar upload da planilha', `Coluna "TIPOCOLETOR" com registro(s) vazio ou nulo.`);
    } else if (valorInvalido) {
      this.protocoloFiscal.exibeMensagem('Erro ao realizar upload da planilha', `Coluna "VALOR" com registro(s) inválido, vazio ou nulo.`);
    } else if (this.protocoloFiscal.protocolo.rateios.length > 0) {

      const dialog = this.protocoloFiscal.exibeMensagem('Anexar Planilha - Rateio',
        'Ao anexar uma planilha, os rateios existentes serão substituídos. Deseja continuar?',
        'confirm');

      dialog.afterClosed().subscribe(confirm => {
        if (confirm != null && confirm) {
          this.protocoloFiscal.limparRateio();
          this.inserirRateio(lstRateiosDespesas);
        }
      });
    } else {
      this.inserirRateio(lstRateiosDespesas);
    }
  }

  inserirRateio(lstRateiosDespesas: Array<RateioDespesas>) {
      this.protocoloFiscal.protocolo.rateios = new Array<RateioDespesas>();
      this.protocoloFiscal.inserirRateios(lstRateiosDespesas);
      this.loadComponent.startLoading(false);
  }

  atualizarNumeroSerialNosRateios(rateios: RateioDespesas[]): RateioDespesas[]{
    if(rateios && rateios.length > 0){
      rateios = this.ordenarRateios(rateios);
      rateios.map((r, index) => {
        if(index === 0){
          r.numeroSerial = 1;
        }
        else{
          let numeroItemAntecessor = rateios[index - 1].item;
          if(r.item === numeroItemAntecessor){
            let numeroSerialAntecessor = rateios[index - 1].numeroSerial;
            let numeroSerialAntecessorTratado = (numeroSerialAntecessor && numeroSerialAntecessor > 0) ? numeroSerialAntecessor : 1;
            r.numeroSerial = numeroSerialAntecessorTratado + 1;
          }
          else {
            r.numeroSerial = 1;
          }
        }

      });
    }

    return rateios;
  }

  ordenarRateios(rateios: RateioDespesas[]): RateioDespesas[]{
    let rateiosOrdenados = rateios.sort(function (a, b) {
      return a.item - b.item;
    });

    return rateiosOrdenados;
  }
}
